// Firestore/Auth imports removed here — this file no longer talks to
// Firebase directly. Login is handled by LoginPage.jsx calling Firebase
// Auth's signInWithEmailAndPassword; this file just holds role logic and
// localStorage helpers now.

// ✅ Role constants for role-based access control
export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  SUPERVISOR: 'supervisor',
  TECHNICIAN: 'technician'
};

// ✅ Role hierarchy (higher number = more privileges)
export const ROLE_HIERARCHY = {
  [ROLES.SUPER_ADMIN]: 4,
  [ROLES.ADMIN]: 3,
  [ROLES.SUPERVISOR]: 2,
  [ROLES.TECHNICIAN]: 1
};

/**
 * Check if user has required role or higher
 * @param {string} userRole - Current user's role
 * @param {string} requiredRole - Minimum required role
 * @returns {boolean}
 */
export const hasRole = (userRole, requiredRole) => {
  return (ROLE_HIERARCHY[userRole] || 0) >= (ROLE_HIERARCHY[requiredRole] || 0);
};

/**
 * Check if user is Super Admin
 * @param {Object} user - User object
 * @returns {boolean}
 */
export const isSuperAdmin = (user) => {
  return user?.role === ROLES.SUPER_ADMIN;
};

/**
 * Check if user is Admin or higher
 * @param {Object} user - User object
 * @returns {boolean}
 */
export const isAdminOrHigher = (user) => {
  return hasRole(user?.role, ROLES.ADMIN);
};

/**
 * Check if user is Supervisor or higher
 * @param {Object} user - User object
 * @returns {boolean}
 */
export const isSupervisorOrHigher = (user) => {
  return hasRole(user?.role, ROLES.SUPERVISOR);
};

// ✅ REMOVED: loginWithPin. PIN login has been fully retired — all
// accounts now use real email/password via Firebase Auth, handled in
// LoginPage.jsx and RegisterPage.jsx directly.

/**
 * Logout current user
 */
export const logout = () => {
  localStorage.removeItem('currentUser');
};

/**
 * Get current user from localStorage
 * @returns {Object|null} - Current user or null
 */
export const getCurrentUser = () => {
  const savedUser = localStorage.getItem('currentUser');
  return savedUser ? JSON.parse(savedUser) : null;
};

/**
 * Check if user is logged in
 * @returns {boolean}
 */
export const isAuthenticated = () => {
  return getCurrentUser() !== null;
};

/**
 * Update current user in localStorage (after profile updates)
 * @param {Object} updatedUser - Updated user data
 */
export const updateCurrentUser = (updatedUser) => {
  localStorage.setItem('currentUser', JSON.stringify(updatedUser));
};
